import React from 'react';
import Button from '../ui/Button';

interface OTPStepProps {
    otp: string;
    setOtp: (otp: string) => void;
    email: string;
    onVerifyCode: () => Promise<void>;
    onResendCode: () => Promise<void>;
    onBackToEmail: () => void;
    isLoading: boolean;
}

const OTPStep: React.FC<OTPStepProps> = ({
                                             otp,
                                             setOtp,
                                             email,
                                             onVerifyCode,
                                             onResendCode,
                                             onBackToEmail,
                                             isLoading,
                                         }) => {
    const handleOtpChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value.replace(/\D/g, '').substring(0, 6);
        setOtp(value);
    };

    const handleKeyPress = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter') {
            onVerifyCode();
        }
    };

    return (
        <div id="otp-step">
            <div className="form-group">
                <label htmlFor="otp">Enter Login Code</label>
                <input
                    type="text"
                    id="otp"
                    className="otp-input"
                    value={otp}
                    onChange={handleOtpChange}
                    onKeyPress={handleKeyPress}
                    placeholder="000000"
                    maxLength={6}
                    required
                />
                <small style={{ color: '#6c757d', fontSize: '12px', marginTop: '5px', display: 'block' }}>
                    Code sent to <span>{email}</span>
                </small>
            </div>
            <Button
                onClick={onVerifyCode}
                loading={isLoading}
                variant="primary"
            >
                Verify Code
            </Button>
            <Button
                onClick={onResendCode}
                variant="secondary"
            >
                Resend Code
            </Button>
            <Button
                onClick={onBackToEmail}
                variant="secondary"
            >
                ← Back to Email
            </Button>
        </div>
    );
};

export default OTPStep;